module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('div', {
    staticClass: "trigger"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.showOptions) ? _vm._t("options") : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166e72bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/Dropdown.vue
// module id = 1022
// module chunks = 1